import React from 'react';
import styles from './Block.module.scss';
import cn from "classnames";

const Block = ({ className, children}) => {
    return (
        <div className={cn(styles.block, className)}>
            { children }
        </div>
    );
};

export default Block;